module.exports = __webpack_public_path__ + "img/momo_layout_top_left.b2856bed.png";